module.exports = __webpack_public_path__ + "static/media/empty.56fb9f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/v2/empty.png
// module id = 1053
// module chunks = 2